module.exports = __webpack_public_path__ + "static/media/defaultAvatar10.bcb530a6.svg";